var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainSection1Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vector-pen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9658 1.09088C18.2953 0.761374 18.8295 0.761374 19.159 1.09088L25.909 7.84088C26.2385 8.17038 26.2385 8.70462 25.909 9.03412L22.6993 12.2439L21.3013 17.8359C21.0847 18.702 20.428 19.39 19.5729 19.6465L2.11646 24.8834L7.3534 7.42696C7.60992 6.57188 8.2979 5.91515 9.16398 5.69863L14.756 4.30062L17.9658 1.09088ZM14.9286 5.99692L9.57325 7.33575C9.28456 7.40792 9.05524 7.62683 8.96973 7.91186L4.63331 22.3666L19.088 18.0302C19.3731 17.9446 19.592 17.7153 19.6641 17.4266L21.003 12.0713L14.9286 5.99692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77881 22.3229L13.5 15.1875C14.4319 15.1875 15.1875 14.432 15.1875 13.5C15.1875 12.568 14.4319 11.8125 13.5 11.8125C12.568 11.8125 11.8125 12.568 11.8125 13.5L4.67695 22.2211L4.63331 22.3666L4.77881 22.3229Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSection1Icon1);
export default __webpack_public_path__ + "static/media/MainSection1_Icon1.79960bcb5e6cd65625447401bfc5f9a4.svg";
export { ForwardRef as ReactComponent };